import { connect } from 'react-redux'
import AssistanceSearch from '../../components/assistance/AssistanceSearch'
import { searchAssistances } from '../../state/actions/assistance/index'
import { IStoreState } from '../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {}
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onInputChange: (query: string) => {
      dispatch(searchAssistances(query))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssistanceSearch)



// WEBPACK FOOTER //
// ./src/containers/assistance/AssistanceSearch.tsx